var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6453 7.52751L6.54727 14.6255L5.47247 18.5287L9.3757 17.4539L16.4737 10.3559L13.6453 7.52751ZM17.8879 8.94172L15.0595 6.1133L15.9672 5.20558C16.0829 5.14701 16.2992 5.05789 16.5635 5.04238C16.8423 5.02602 17.4001 5.06914 18.1661 5.83512C18.9321 6.60109 18.9752 7.15895 18.9588 7.43771C18.9433 7.70205 18.8542 7.91836 18.7956 8.03401L17.8879 8.94172ZM14.7716 3.58983C14.7333 3.61528 14.6991 3.64525 14.6666 3.67775L4.9462 13.3982C4.82374 13.5206 4.73517 13.6728 4.68919 13.8398L3.07699 19.6946C2.87099 20.4427 3.55848 21.1302 4.30659 20.9242L10.1614 19.312C10.3284 19.266 10.4806 19.1775 10.6031 19.055L20.3235 9.33461C20.356 9.30211 20.3859 9.26789 20.4114 9.22962C20.6562 8.86129 21.8943 6.73486 19.5803 4.4209C17.2663 2.10695 15.1399 3.34499 14.7716 3.58983Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.915fd356eb8dc81699485f8150af5b09.svg";
export { ForwardRef as ReactComponent };